module.exports = __webpack_public_path__ + "static/img/new-22.5afc843c.jpg";